import React, { Component } from 'react';
import Datas from '../../data/shop/mondiya/productCategory001.json';
import Datas2 from '../../data/shop/mondiya/productCategory002.json';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/mondiya/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/mondiya/Breadcrumb';
import FooterTwo from '../../components/mondiya/FooterTwo';
import { Styles } from './styles/mondiya/productCategory.js';
import { withTranslation } from 'react-i18next';

class ProductCategory extends Component {
    render() {
        const { t } = this.props;
        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper product-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Breadcroumb */}
                    <BreadcrumbBox title={t('shop.breadcrumbs1')} />

                    {/* Products */}
                    <section className="product-area">
                        <Container>
                            <Row>
                                <Col lg="12" md="12" sm="12">
                                    <Row>
                                        <Col lg="12" md="12" className="product-top-navbar">
                                            <nav className="navbar navbar-dark bg-dark">
                                                <span className="navbar-brand mb-0 h1">{t('shop.home')} > {t('shop.productCategory.category_header_mfv001')}</span>
                                            </nav>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {
                                            Datas.map((data, i) => (
                                                <Col lg="3" md="4" key={i}>
                                                    <div className="product-box">
                                                        <div className="product-img">
                                                            <img src={process.env.PUBLIC_URL + `/assets/images/${data.productImg}`} alt="" className="img-fluid" />
                                                            <div className="layer-box"></div>
                                                            <Link className="item_view" to={process.env.PUBLIC_URL + data.productUrl}>{t('shop.productCategory.view_item')}</Link>
                                                        </div>
                                                        <div className="product-content text-center">
                                                            <div className="pro-title">
                                                                <h5><Link to={process.env.PUBLIC_URL + data.productUrl}>{t(`shop.productCategory.categories.${data.category_id_slug}`)}</Link></h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            ))
                                        }
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12" md="12" sm="12">
                                    <Row>
                                        <Col lg="12" md="12" className="product-top-navbar">
                                            <nav className="navbar navbar-dark bg-dark">
                                                <span className="navbar-brand mb-0 h1">{t('shop.home')} > {t('shop.productCategory.category_header_mfv002')}</span>
                                            </nav>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {
                                            Datas2.map((data2, i) => (
                                                <Col lg="3" md="4" key={i}>
                                                    <div className="product-box">
                                                        <div className="product-img">
                                                            <img src={process.env.PUBLIC_URL + `/assets/images/${data2.productImg}`} alt="" className="img-fluid" />
                                                            <div className="layer-box"></div>
                                                            <Link className="item_view" to={process.env.PUBLIC_URL + data2.productUrl}>{t('shop.productCategory.view_item')}</Link>
                                                        </div>
                                                        <div className="product-content text-center">
                                                            <div className="pro-title">
                                                                <h5><Link to={process.env.PUBLIC_URL + data2.productUrl}>{t(`shop.productCategory.categories.${data2.category_id_slug}`)}</Link></h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            ))
                                        }
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </section>

                    {/* Footer 2 */}
                    <FooterTwo />

                </div>
            </Styles>
        )
    }
}

export default withTranslation()(ProductCategory)